module.exports = __webpack_public_path__ + "static/media/arrow-square-right.394c934b.svg";